/**
 * Spartan desktop mega menu (snippets/sf-mega-nav.liquid).
 * - Hover opens after a short pause (no flashing when the mouse passes); moving between
 *   items while one is open switches instantly; leaving the header closes after a moment.
 * - Click/Enter/↓ toggles; Esc closes and returns focus. Touch: first tap opens.
 * - Locations panel: "your store" card + all showrooms by province, from the store data the
 *   nearest-store widget already outputs (#SpartanMetaobjectStoresData). Clicking the header
 *   store button on desktop opens this same panel.
 */
(function () {
  const nav = document.querySelector('.sf-nav');
  if (!nav) return;
  const header = nav.closest('.section-header') || nav.parentElement;
  const tops = [...nav.querySelectorAll('[data-sf-panel]')];
  const desktop = window.matchMedia('(min-width: 990px)');
  let open = null, hoverT = 0, leaveT = 0, hideT = 0;

  const panelOf = (a) => document.getElementById(a.dataset.sfPanel);
  function show(a) {
    if (open === a) return;
    hide(true);
    clearTimeout(hideT);
    nav.querySelectorAll('.sf-nav__panel').forEach((q) => { if (q !== panelOf(a)) { q.classList.remove('is-open'); q.hidden = true; } });
    const p = panelOf(a);
    p.hidden = false;
    void p.offsetWidth; // start the fade from the hidden state without waiting a frame
    p.classList.add('is-open');
    a.setAttribute('aria-expanded', 'true');
    open = a;
    if (p.querySelector('[data-sf-navstores]')) fillStores(p);
  }
  function hide(instant) {
    if (!open) return;
    const p = panelOf(open);
    open.setAttribute('aria-expanded', 'false');
    p.classList.remove('is-open');
    clearTimeout(hideT);
    if (instant) p.hidden = true; else hideT = setTimeout(() => { if (!p.classList.contains('is-open')) p.hidden = true; }, 160);
    open = null;
  }

  tops.forEach((a) => {
    a.addEventListener('mouseenter', () => {
      if (!desktop.matches) return;
      clearTimeout(leaveT); clearTimeout(hoverT);
      hoverT = setTimeout(() => show(a), open ? 0 : 140);
    });
    a.addEventListener('mouseleave', () => clearTimeout(hoverT));
    let touched = false;
    a.addEventListener('touchstart', () => { touched = true; }, { passive: true });
    a.addEventListener('click', (e) => {
      // Mouse: panels open on hover, so a click always goes to the page.
      // Touch: first tap opens the panel, second tap follows the link.
      // Keyboard (Enter): opens the panel; Enter again follows the link.
      const keyboard = e.detail === 0;
      if (!touched && !keyboard) return;
      touched = false;
      if (open !== a) { e.preventDefault(); show(a); }
    });
    a.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') { e.preventDefault(); show(a); panelOf(a).querySelector('a')?.focus(); }
    });
  });
  nav.querySelectorAll('.sf-nav__panel').forEach((p) => {
    p.addEventListener('mouseenter', () => clearTimeout(leaveT));
  });
  nav.addEventListener('mouseleave', () => { leaveT = setTimeout(() => hide(), 260); });
  nav.addEventListener('mouseenter', () => clearTimeout(leaveT));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && open) { const a = open; hide(true); a.focus(); }
  });
  document.addEventListener('click', (e) => { if (open && !nav.contains(e.target) && !e.target.closest('.spartan-nearest-store-trigger')) hide(); });
  nav.addEventListener('focusout', (e) => { if (open && !nav.contains(e.relatedTarget)) hide(); });

  /* ---------- Locations panel ---------- */
  let stores = null;
  function readStores() {
    if (stores) return stores;
    try { stores = JSON.parse(document.getElementById('SpartanMetaobjectStoresData')?.textContent || '[]'); } catch (e) { stores = []; }
    return stores;
  }
  const PROV = { BC: 'British Columbia', AB: 'Alberta', SK: 'Saskatchewan', MB: 'Manitoba', ON: 'Ontario', QC: 'Quebec', NS: 'Atlantic', PE: 'Atlantic', NL: 'Atlantic', NB: 'Atlantic' };
  const ORDER = ['British Columbia', 'Alberta', 'Saskatchewan', 'Manitoba', 'Ontario', 'Quebec', 'Atlantic'];
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function todayHours(s) {
    try {
      const day = new Date().toLocaleString('en-US', { weekday: 'short', timeZone: s.timezone || 'America/Toronto' });
      const i = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(day);
      return s.schedule ? s.schedule[String(i)] : '';
    } catch (e) { return ''; }
  }
  function openNow(h) {
    const m = String(h || '').match(/(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*[-–]\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i);
    if (!m) return /closed/i.test(h || '') ? false : null;
    const t = (hh, mm, ap) => ((+hh % 12) + (/pm/i.test(ap) ? 12 : 0)) * 60 + (+mm || 0);
    const d = new Date(); const now = d.getHours() * 60 + d.getMinutes();
    return now >= t(m[1], m[2], m[3]) && now < t(m[4], m[5], m[6]);
  }
  function fillStores(p) {
    const list = readStores();
    const w = window.spartanStoreWidgetInstance;
    const cur = (w && w.currentStore) || list[0];
    const box = p.querySelector('[data-sf-mystore]');
    if (cur && box) {
      const hours = todayHours(cur);
      const addr = [cur.address, cur.city, cur.province].filter(Boolean).join(', ');
      const dir = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent([cur.address, cur.city, cur.province, cur.postal].filter(Boolean).join(', '));
      const open = openNow(hours);
      const tel = cur.phone ? String(cur.phone).replace(/[^\d+]/g, '') : '';
      const I = (d) => `<svg class="sf-nav__ico" viewBox="0 0 24 24" aria-hidden="true">${d}</svg>`;
      box.innerHTML = `<div class="sf-nav__storetop"><p class="sf-nav__label">Your store</p>${open === null ? '' : `<span class="sf-nav__status${open ? ' is-open' : ''}">${open ? 'Open now' : 'Closed now'}</span>`}</div>
        <strong class="sf-nav__storename">Spartan Fitness ${esc(cur.city)}</strong>
        <ul class="sf-nav__storeinfo" role="list">
          <li>${I('<path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>')}<span>${esc(addr)}</span></li>
          ${hours ? `<li>${I('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>')}<span>Today ${esc(hours)}</span></li>` : ''}
          ${tel ? `<li>${I('<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>')}<a href="tel:${esc(tel)}">${esc(cur.phone)}</a></li>` : ''}
        </ul>
        <div class="sf-nav__storeacts">
          <a class="sf-nav__btn sf-nav__btn--main" href="${dir}" target="_blank" rel="noopener">Get directions</a>
          <a class="sf-nav__btn" href="${esc(cur.website || '#')}">Store details</a>
        </div>
        <button class="sf-nav__changelink" type="button" data-sf-change>Not your store? Change store</button>`;
      box.querySelector('[data-sf-change]').onclick = () => {
        // Use the header's own store picker (same one as the "Your store" button)
        hide(true);
        const wi = window.spartanStoreWidgetInstance;
        if (wi && wi.openDropdown) { window.scrollTo({ top: 0 }); setTimeout(() => wi.openDropdown(), 60); }
        else document.querySelector('.spartan-nearest-store-trigger')?.click();
      };
    }
    const provs = p.querySelector('[data-sf-provs]');
    if (provs) {
      const groups = {};
      list.forEach((s) => { const g = PROV[(s.province || '').trim().toUpperCase()] || 'Other'; (groups[g] = groups[g] || []).push(s); });
      provs.innerHTML = ORDER.concat(Object.keys(groups).filter((g) => !ORDER.includes(g))).filter((g) => groups[g]).map((g) =>
        `<div><p class="sf-nav__label">${esc(g)}</p><ul role="list">${groups[g].map((s) => `<li><a href="${esc(s.website || '#')}"${cur && s.city === cur.city ? ' class="is-current"' : ''}>${esc(s.city)}</a></li>`).join('')}</ul></div>`).join('')
        + `<a class="sf-nav__all" href="${esc(p.querySelector('[data-sf-navstores]').dataset.allUrl)}">All locations and hours →</a>`;
    }
  }
  document.addEventListener('spartan:store_changed', () => { const p = document.querySelector('.sf-nav__panel--loc'); if (p && !p.hidden) fillStores(p); });

})();
